import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import ArtFrame from "@/components/ArtFrame";
import ArtBackdrop from "@/components/ArtBackdrop";
import { ART_COLLECTION, ARTIST } from "@/lib/artCollection";

export default function Galerie() {
  return (
    <div className="min-h-screen bg-[#FAF7F1] text-[#0B3A2A]">
      <Seo
        title="Galerie · Joakim Sorola — CONFILEX"
        description="CONFILEX présente une sélection d'œuvres de Joakim Sorola, dans une logique de mécénat culturel discret. Mer, lumière, étoffe — un dialogue entre expertise et sensibilité."
      />
      <Navbar variant="light" />

      {/* HERO MUSÉAL */}
      <section className="relative pt-28 pb-20 overflow-hidden">
        <ArtBackdrop src="/art/sorola/promenade-2.jpg" opacity={0.22} blur={26} saturate={0.7}
          overlay="linear-gradient(180deg, rgba(250,247,241,0.85) 0%, rgba(250,247,241,0.95) 75%)" />
        <div className="relative max-w-5xl mx-auto px-6">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#C9A961] mb-5">
            Collection CONFILEX · Mécénat
          </p>
          <h1 className="font-serif italic text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight">
            Quand la lumière<br />rencontre l'expertise
          </h1>
          <div className="w-16 h-px bg-[#C9A961] my-8" />
          <p className="text-base sm:text-lg text-slate-700 leading-relaxed max-w-2xl">
            CONFILEX présente, dans son espace institutionnel, une sélection d'œuvres
            du peintre <span className="text-[#0B3A2A] font-medium">{ARTIST.name}</span>.
            Une manière de rappeler que la rigueur professionnelle n'exclut ni la sensibilité,
            ni l'attention au beau.
          </p>
        </div>
      </section>

      {/* GRILLE MUSÉALE */}
      <section className="py-16 bg-[#FAF7F1]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex items-end justify-between mb-10 border-b border-[#0B3A2A]/10 pb-5">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#C9A961] mb-1.5">
                Cabinet d'exposition
              </p>
              <h2 className="font-serif italic text-2xl sm:text-3xl text-[#0B3A2A]">
                Sélection actuelle
              </h2>
            </div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 hidden sm:block">
              {ART_COLLECTION.length} œuvres présentées
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 sm:gap-14">
            {ART_COLLECTION.map((art) => (
              <ArtFrame
                key={art.id}
                art={art}
                artistName={ARTIST.name}
                size="md"
                showNote={true}
              />
            ))}
          </div>
        </div>
      </section>

      {/* NOTICE ARTISTE */}
      <section className="py-20 bg-white border-y border-[#0B3A2A]/8">
        <div className="max-w-3xl mx-auto px-6">
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#C9A961] mb-3">
            Notice de l'artiste
          </p>
          <h2 className="font-serif italic text-3xl sm:text-4xl text-[#0B3A2A] mb-6">
            {ARTIST.name}
          </h2>
          <p className="text-slate-700 leading-relaxed text-[15px] mb-6">
            {ARTIST.bio}
          </p>
          <div className="w-12 h-px bg-[#C9A961] mb-6" />
          <p className="text-slate-500 text-[13px] italic leading-relaxed">
            {ARTIST.curator_note}
          </p>
        </div>
      </section>

      {/* SECTION DE CLÔTURE */}
      <section className="py-20 bg-[#0B3A2A] text-white relative overflow-hidden">
        <ArtBackdrop src="/art/sorola/ete-2.jpg" opacity={0.14} blur={30} saturate={0.6}
          overlay="linear-gradient(180deg, rgba(11,58,42,0.85) 0%, rgba(11,58,42,0.95) 100%)" />
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <p className="text-[11px] uppercase tracking-[0.32em] text-[#C9A961] mb-4">
            Esprit CONFILEX
          </p>
          <p className="font-serif italic text-2xl sm:text-3xl leading-relaxed text-white/90">
            « Une expertise sérieuse ne se prive ni de silence,<br className="hidden sm:block" /> ni de beauté. »
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
